import React, { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import "./AddRole.css";
import DashNav from "../../Components/DashNav/DashNav";
import Gbtn from "../../Components/buttons/Gbtn";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import EmployeeSVG from "../../Components/SVGS/EmployeeSVG";
import InputField from "../../Components/InputField/InputField";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import "animate.css";
import noImage from "../../Assests/avatar1.png";
import { deleteClient, postClient } from "../../api";
import validator from "validator";

function AddRole({ isEdit, isDelete }) {
  const icon = () => {
    return <EmployeeSVG size="28" fill="#DF2F35" />;
  };

  const location = useLocation();
  const clientEdit =
    location.state && location.state ? location.state.clientToEdit : null;
  const page = location.state && location.state ? location.state.page : null;

  let baseUrl = process.env.REACT_APP_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);
  const [profileImage, setProfileImage] = useState("");
  const [editImage, setEditImage] = useState("");
  const [err, setErr] = useState(false);
  const [errMsg, setErrMsg] = useState(false);
  const [imageErr, setImageErr] = useState(false);
  const [nameErr, setNameErr] = useState(false);
  const [urlErr, setUrlErr] = useState(false);
  const [isValidUrl, setIsValidUrl] = useState(true);
  // const [urlValidErr, setUrlValidErr] = useState(false)
  const [imgInputErr, setImgInputErr] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [client, setClient] = useState({
    id: clientEdit ? clientEdit.id : 0,
    name: clientEdit ? clientEdit.name : "",
    image_path: clientEdit ? clientEdit.image_path : "",
    website_link: clientEdit ? clientEdit.website_link : "",
  });

  // fetching initial data
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setEditImage(clientEdit ? clientEdit.image_path : "");
  }, []);

  useEffect(() => {
    Modal.setAppElement("#root");
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setClient({ ...client, [name]: value });
  };

  const navigate = useNavigate();

  const saveOnclick = () => {
    // if (client.name === "") setNameErr(true);
    // else if (client.website_link === "") {
    //   setNameErr(false);
    //   setIsValidUrl(true);
    //   setUrlErr(true);
    // } else
    if (
      client.website_link &&
      client.website_link !== "" &&
      !validate(client.website_link)
    ) {
      setNameErr(false);
      setIsValidUrl(false);
    } else if (editImage === "" && profileImage === "") {
      setUrlErr(false);
      setNameErr(false);
      setIsValidUrl(true);
      setImgInputErr(true);
    } else {
      setUrlErr(false);
      setNameErr(false);
      setIsValidUrl(true);
      setImgInputErr(false);
      setIsLoading(true);
      setErr(false);
      let formData = new FormData();
      formData.append("id", client.id);
      formData.append("name", `${client.name}`);
      formData.append("website_link", `${client.website_link}`);
      if (typeof profileImage == "string")
        formData.append("image_path", editImage);
      else formData.append("image", profileImage, profileImage.name);

      postClient(formData)
        .then(({ data }) => {
          // console.log("client response", data);
          setIsLoading(false);
          if (data.success) {
            navigate("/dashboard/clients", {
              state: { page: page },
            });
          } else {
            setErr(true);
            setErrMsg(data.message);
          }
        })
        .catch((err) => {
          console.log("client add Error: ", err);
          setErr(true);
          setIsLoading(false);
          if (err.message === "Request failed with status code 400")
            setErrMsg("All Fields Required");
          else setErrMsg(err.message);
        });
    }
  };

  const discardOnclick = () => {
    setModalIsOpen(true);
  };

  const onSelectImage = (img) => {
    if (
      img.type.includes("png") ||
      img.type.includes("jpg") ||
      img.type.includes("jpeg")
    ) {
      setProfileImage(img);
      setImageErr(false);
      setEditImage("");
    } else {
      alert("Invalid File!");
    }
  };

  const handleImageErr = () => {
    setImageErr(true);
  };

  const deleteClick = () => {
    let obj = {
      id: clientEdit ? clientEdit.id : null,
    };
    setIsLoading(true);
    deleteClient(obj)
      .then(({ data }) => {
        setIsLoading(false);
        setModalIsOpen(false);
        if (data.success) {
          navigate("/dashboard/clients", {
            state: { page: page },
          });
        } else {
          setErr(true);
          setErrMsg(data.message);
        }
      })
      .catch((err) => {
        console.log("delete axios error", err);
        setErr(true);
        setModalIsOpen(false);
        setIsLoading(false);
      });
  };

  const validate = (val) => {
    if (validator.isURL(val))
      // setIsValidUrl(true)
      return true;
    else setIsValidUrl(false);
    return false;
  };

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        className="deleteModal animate__animated animate__zoomIn"
        style={{ display: "flex" }}
      >
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div
              className="delClient-cross"
              onClick={(e) => {
                setModalIsOpen(false);
              }}
            >
              <RxCross2 color="white" size={"20"} />
            </div>
            <>
              <h3 style={{ color: "white", marginBottom: "60px" }}>
                Are you sure you want to delete?
              </h3>

              <Gbtn
                text="Delete"
                color="#EE282E"
                radius="6px"
                width="40%"
                func={deleteClick}
              />
            </>
          </>
        )}
      </Modal>

      <div className="mainDashView">
        <div>
          <DashNav svg={icon} DashboardNavText={"Clients"} />
        </div>
        <div className="dashPanel" style={{ position: "relative" }}>
          <h4
            style={{
              display: err ? "flex" : "none",
              justifyContent: "center",
              color: "red",
            }}
          >
            <p>Network Error! Check your Network connnection.</p>
          </h4>
          <>
            <div className="ar-dashpanel">
              <h4
                style={{
                  display: err ? "flex" : "none",
                  justifyContent: "center",
                  color: "red",
                  position: "absolute",
                  top: "0",
                  width: "90%",
                }}
              >
                <p>Error! {errMsg}.</p>
              </h4>
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <LoadingSpinner />
                </div>
              ) : (
                <div>
                  {/* <div>
                    <div className="ae-formFields">
                      <div className="ae-inputField">
                        <InputField
                          name={"name"}
                          isErr={nameErr}
                          errorMsg="Name is required"
                          value={clientEdit ? clientEdit.name : null}
                          onChange={(e) => {
                            setNameErr(false);
                            handleChange(e);
                          }}
                          placeholder={"Name"}
                          radius="5px"
                        />
                      </div>
                    </div>
                  </div> */}
                  <div className="ae-formFields">
                    <div className="ae-inputField">
                      <InputField
                        name={"website_link"}
                        isErr={urlErr || !isValidUrl}
                        errorMsg={
                          !isValidUrl ? "Not a Valid URL" : "Url is required"
                        }
                        value={clientEdit ? clientEdit.website_link : null}
                        onChange={(e) => {
                          setUrlErr(false);
                          handleChange(e);
                        }}
                        placeholder={"URL"}
                        radius="5px"
                      />
                    </div>
                  </div>
                  <div className="if-txt" style={{ marginTop: "40px" }}>
                    Add Image
                  </div>
                  <div className="Add_Client_Image_container">
                    <label className="changeimage-label">
                      {editImage || profileImage ? (
                        <>
                          <img
                            src={
                              editImage
                                ? `${baseUrl + editImage}`
                                : URL.createObjectURL(profileImage)
                            }
                            onError={handleImageErr}
                            alt="cp"
                            height="120px"
                            width="120px"
                            className="add-image-Style"
                          />
                          <div>
                            <input
                              type="file"
                              className="formuploadimage_input"
                              accept=".png, .jpg, jpeg"
                              onChange={(e) => {
                                setImgInputErr(false);
                                onSelectImage(e.target.files[0]);
                              }}
                              onClick={(event) =>
                                (event.currentTarget.value = null)
                              }
                            />
                          </div>
                        </>
                      ) : (
                        <div className="AddimageBtn">
                          <span className="cam_Image_upload">+</span>
                          <div>
                            <input
                              type="file"
                              className="formuploadimage_input"
                              accept=".png, .jpg, jpeg"
                              onChange={(e) => {
                                setImgInputErr(false);
                                onSelectImage(e.target.files[0]);
                              }}
                              onClick={(event) =>
                                (event.currentTarget.value = null)
                              }
                            />
                          </div>
                        </div>
                      )}
                    </label>
                  </div>
                  <div
                    className="err-txt"
                    style={{
                      display: imgInputErr ? "flex" : "none",
                      width: "150px",
                    }}
                  >
                    image is required
                  </div>
                </div>
              )}
              <div className="addEdit-btns">
                <div className="ev-btnAdd ev-btn">
                  <Gbtn
                    text={isEdit ? "Update" : isDelete ? "Delete" : "Add"}
                    func={isDelete ? discardOnclick : saveOnclick}
                    disabled={isLoading}
                    color="#DF2F35"
                    radius="5px"
                    width="150px"
                  />
                </div>
                <div className="ev-btnDel ev-btn">
                  <Gbtn
                    text={isEdit ? "Discard" : "Back"}
                    color="#0061B1"
                    func={() => {
                      navigate("/dashboard/clients", {
                        state: { page: page },
                      });
                    }}
                    radius="5px"
                    width="150px"
                  />
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
}

export default AddRole;
